import { render } from "./Assorted_shop.vue?vue&type=template&id=f25ff6e4&scoped=true&ts=true"
import script from "./Assorted_shop.vue?vue&type=script&lang=ts"
export * from "./Assorted_shop.vue?vue&type=script&lang=ts"

import "./Assorted_shop.vue?vue&type=style&index=0&id=f25ff6e4&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f25ff6e4"]])

export default __exports__